'use client';

import { useRef } from 'react';
import { useInView } from 'framer-motion';
import cx from 'classnames';

interface IToTop {
    className?: string;
}

const ToTop = ({ className = '' }: IToTop) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { margin: '0px 0px -25% 0px' });

    const handleToTop = () => {
        const app = document.getElementById('app');

        if (app) {
            app.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <div ref={ref} onClick={handleToTop} className={cx('group text-white bg-primary-500 rounded-full pb-12 px-0.5 transition-all duration-300 ease-in-out', {
            '-translate-y-1/2 opacity-100 cursor-pointer': isInView === true,
            'translate-y-0 opacity-0': isInView === false,
            [className]: Boolean(className)
        })}>
            <div className='w-8 h-8 py-1 px-1 mt-0.5 aspect-square group-hover:bg-primary-800/25 rounded-full duration-300 transition-all'>
                <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' strokeWidth={1.5} stroke='currentColor' className='w-full h-full group-hover:animate-bounce'>
                    <path strokeLinecap='round' strokeLinejoin='round' d='M12 19.5v-15m0 0l-6.75 6.75M12 4.5l6.75 6.75' />
                </svg>
            </div>
        </div>
    );
};

export { ToTop };